import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from "@angular/router";

@Injectable()
export class SiteworkAuth implements CanActivate {
    private router: Router;
    private http: HttpClient;

    constructor(router: Router, http: HttpClient) {
        this.router = router;
        this.http = http;
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(route);
    }

    private async isAllowedAccess(
        route: ActivatedRouteSnapshot
    ): Promise<boolean> {
        var result: boolean = false;
        var url =
            "api/SiteworkAuthorization/" +
            route.data.siteworkSection +
            "/" +
            route.params.projectId +
            "/" +
            route.params.entryNumber +
            "/" +
            route.queryParams.securityToken;

        try {
            var data = await this.http
                .get(url, { responseType: "text" })
                .toPromise();
            if (data != null) {
                let access = data.toLowerCase();
                let mode = route.data.mode;

                if (access == "edit") result = true;
                else if (
                    access == "view" &&
                    (mode == "view" || mode == "review")
                )
                    result = true;
            }
        } catch (err) {
            console.log(err);
        }

        if (!result)
            this.router.navigateByUrl(
                "/unauthorized?security=" + route.data.siteworkSection
            );

        return result;
    }
}
